export type Integration = {
  name: string
  description: string
  icon: string
  status: string
  class: string
  href: string | null
  planRequired?: string
  type: string | null
  service?: string
  id?: string
}

export const integrations: Integration[] = [
  {
    id: "acumbamail",
    name: "Acumbamail",
    description: "Connect your Acumbamail email marketing platform",
    icon: "https://img.promoamp.com/icons/acumbamail.svg",
    status: "Available",
    class: "h-[30px]",
    href: "/acumbamail",
    planRequired: "Growth",
    type: "Email",
    service: "acumbamail",
  },
  {
    id: "activecampaign",
    name: "ActiveCampaign",
    description: "Connect your ActiveCampaign marketing automation platform",
    icon: "https://img.promoamp.com/icons/activecampaign.svg",
    status: "Beta",
    class: "h-[30px]",
    href: "/activecampaign",
    planRequired: "Growth",
    type: "Email",
    service: "activecampaign",
  },
  {
    id: "aweber",
    name: "AWeber",
    description: "Connect your AWeber email marketing service",
    icon: "https://img.promoamp.com/icons/aweber.svg",
    status: "Beta",
    class: "h-[30px]",
    href: "/aweber",
    planRequired: "Growth",
    type: "Email",
    service: "aweber",
  },
  {
    id: "beehiiv",
    name: "Beehiiv",
    description: "Integrate with Beehiiv newsletter platform",
    icon: "https://img.promoamp.com/icons/beehiiv.svg",
    status: "Beta",
    class: "h-[30px]",
    href: "/beehiiv",
    planRequired: "Growth",
    type: "Email",
    service: "beehiiv",
  },
  {
    id: "benchmark",
    name: "Benchmark",
    description: "Connect your Benchmark email marketing platform",
    icon: "https://img.promoamp.com/icons/benchmark.svg",
    status: "Beta",
    class: "h-[30px]",
    href: "/benchmark",
    planRequired: "Growth",
    type: "Email",
    service: "benchmark",
  },
  // {
  //   id: "boostspace",
  //   name: "Boost.space",
  //   description: "Connect your Boost.space automation platform",
  //   icon: "https://img.promoamp.com/icons/boostspace.svg",
  //   status: "Beta",
  //   class: "h-[30px]",
  //   href: "/boostspace",
  //   planRequired: "Growth",
  //   type: "Email",
  //   service: "boostspace",
  // },
  {
    id: "campaignmonitor",
    name: "Campaign Monitor",
    description: "Sync your Campaign Monitor email campaigns",
    icon: "https://img.promoamp.com/icons/campaignmonitor.svg",
    status: "Beta",
    class: "h-[30px]",
    href: "/campaignmonitor",
    planRequired: "Growth",
    type: "Email",
    service: "campaignmonitor",
  },
  {
    id: "drip",
    name: "Drip",
    description: "Connect your Drip email marketing automation",
    icon: "https://img.promoamp.com/icons/drip.svg",
    status: "Beta",
    class: "h-[30px]",
    href: "/drip",
    planRequired: "Growth",
    type: "Email",
    service: "drip",
  },
  // {
  //   id: "encharge",
  //   name: "Encharge",
  //   description: "Connect your Encharge marketing automation platform",
  //   icon: "https://img.promoamp.com/icons/encharge.svg",
  //   status: "Beta",
  //   class: "h-[30px]",
  //   href: "/encharge",
  //   planRequired: "Growth",
  //   type: "Email",
  //   service: "encharge",
  // },
  {
    id: "getresponse",
    name: "GetResponse",
    description: "Sync your GetResponse email marketing campaigns",
    icon: "https://img.promoamp.com/icons/getresponse.svg",
    status: "Beta",
    class: "h-[30px]",
    href: "/getresponse",
    planRequired: "Growth",
    type: "Email",
    service: "getresponse",
  },
  {
    id: "googlesheets",
    name: "Google Sheets",
    description: "Export your data directly to Google Sheets spreadsheets",
    icon: "https://img.promoamp.com/icons/googlesheets.svg",
    status: "Available",
    class: "h-[30px]",
    href: "/googlesheets",
    planRequired: "Growth",
    type: "Export",
    service: "googlesheets",
  },
  {
    id: "keap",
    name: "Keap",
    description: "Connect your Keap CRM and marketing automation platform",
    icon: "https://img.promoamp.com/icons/keap.svg",
    status: "Available",
    class: "h-[30px]",
    href: "/keap",
    planRequired: "Growth",
    type: "Email",
    service: "keap",
  },
  {
    id: "kit",
    name: "Kit",
    description: "Sync your Kit creator marketing platform",
    icon: "https://img.promoamp.com/icons/kit.svg",
    status: "Beta",
    class: "h-[30px]",
    href: "/kit",
    planRequired: "Growth",
    type: "Email",
    service: "kit",
  },
  {
    id: "klaviyo",
    name: "Klaviyo",
    description: "Integrate email and SMS marketing automation",
    icon: "https://img.promoamp.com/icons/klaviyo.svg",
    status: "Available",
    class: "h-[30px]",
    href: "/klaviyo",
    planRequired: "Growth",
    type: "Email",
    service: "klaviyo",
  },
  {
    id: "mailchimp",
    name: "Mailchimp",
    description: "Sync your email marketing campaigns and audience data",
    icon: "https://img.promoamp.com/icons/mailchimp.svg",
    status: "Available",
    class: "h-[40px]",
    href: "/mailchimp",
    planRequired: "Growth",
    type: "Email",
    service: "mailchimp",
  },
  {
    id: "mailerlite",
    name: "MailerLite",
    description: "Connect your MailerLite email marketing platform",
    icon: "https://img.promoamp.com/icons/mailerlite.svg",
    status: "Available",
    class: "h-[30px]",
    href: "/mailerlite",
    planRequired: "Growth",
    type: "Email",
    service: "mailerlite",
  },
  {
    id: "mailjet",
    name: "MailJet",
    description: "Sync your email marketing campaigns and audience data",
    icon: "https://img.promoamp.com/icons/mailjet.svg",
    status: "Available",
    class: "h-[30px]",
    href: "/mailjet",
    planRequired: "Growth",
    type: "Email",
    service: "mailjet",
  },
  {
    id: "omnisend",
    name: "Omnisend",
    description: "Connect your Omnisend omnichannel marketing platform",
    icon: "https://img.promoamp.com/icons/omnisend.svg",
    status: "Available",
    class: "h-[30px]",
    href: "/omnisend",
    planRequired: "Growth",
    type: "Email",
    service: "omnisend",
  },
  {
    id: "pabbly",
    name: "Pabbly Email Marketing",
    description:
      "Connect your Pabbly Email Marketing account to send unlimited emails",
    icon: "https://img.promoamp.com/icons/pabbly.svg",
    status: "Available",
    class: "h-[30px]",
    href: "/pabbly",
    planRequired: "Growth",
    type: "Email",
    service: "pabbly",
  },
  {
    id: "sendy",
    name: "Sendy",
    description: "Integrate with your self-hosted Sendy email platform",
    icon: "https://img.promoamp.com/icons/sendy.png",
    status: "Beta",
    class: "h-[30px]",
    href: "/sendy",
    planRequired: "Growth",
    type: "Email",
    service: "sendy",
  },
  {
    id: "sendfox",
    name: "SendFox",
    description: "Connect your SendFox account to sync contacts and campaigns",
    icon: "https://img.promoamp.com/icons/sendfox.svg",
    status: "Available",
    class: "h-[30px]",
    href: "/sendfox",
    planRequired: "Growth",
    type: "Email",
    service: "sendfox",
  },
  {
    id: "swipeone",
    name: "SwipeOne",
    description: "Connect your SwipeOne CRM and marketing automation platform",
    icon: "https://img.promoamp.com/icons/swipeone.svg",
    status: "Available",
    class: "h-[30px]",
    href: "/swipeone",
    planRequired: "Growth",
    type: "Email",
    service: "swipeone",
  },
  {
    id: "useinbox",
    name: "useinbox.com",
    description: "Connect your useinbox.com email marketing platform",
    icon: "https://img.promoamp.com/icons/useinbox.png",
    status: "Beta",
    class: "h-[30px]",
    href: "/useinbox",
    planRequired: "Growth",
    type: "Email",
    service: "useinbox",
  },
  {
    id: "vbout",
    name: "Vbout",
    description: "Connect your Vbout marketing automation platform",
    icon: "https://img.promoamp.com/icons/vbout.png",
    status: "Available",
    class: "h-[30px]",
    href: "/vbout",
    planRequired: "Growth",
    type: "Email",
    service: "vbout",
  },
]

// Entry Action Integrations (separate from main integrations)
export const entryActionsIntegrations: Integration[] = [
  {
    id: "facebook",
    name: "Facebook",
    description: "Direct entrants to a Facebook Page or selected content",
    icon: "https://img.promoamp.com/icons/facebook.svg",
    status: "Available",
    class: "h-[30px]",
    href: null,
    type: "Entry Actions",
    service: "facebook",
  },
  {
    id: "instagram",
    name: "Instagram",
    description: "Direct entrants to an Instagram profile or selected content",
    icon: "https://img.promoamp.com/icons/instagram.svg",
    status: "Available",
    class: "h-[30px]",
    href: null,
    type: "Entry Actions",
    service: "instagram",
  },
  {
    id: "pinterest",
    name: "Pinterest",
    description: "Direct entrants to a Pinterest profile or selected pin",
    icon: "https://img.promoamp.com/icons/pinterest.svg",
    status: "Available",
    class: "h-[30px]",
    href: null,
    type: "Entry Actions",
    service: "pinterest",
  },
  {
    id: "reddit",
    name: "Reddit",
    description: "Direct entrants to a subreddit or selected Reddit post",
    icon: "https://img.promoamp.com/icons/reddit.svg",
    status: "Available",
    class: "h-[30px]",
    href: null,
    type: "Entry Actions",
    service: "reddit",
  },
  {
    id: "whatsapp",
    name: "WhatsApp",
    description: "Open a configured WhatsApp share or group link",
    icon: "https://img.promoamp.com/icons/whatsapp.svg",
    status: "Available",
    class: "h-[30px]",
    href: null,
    type: "Entry Actions",
    service: "whatsapp",
  },
  {
    id: "tiktok",
    name: "TikTok",
    description: "Direct entrants to a TikTok profile or selected video",
    icon: "https://img.promoamp.com/icons/tiktok.svg",
    status: "Available",
    class: "h-[30px]",
    href: null,
    type: "Entry Actions",
    service: "tiktok",
  },
  {
    id: "telegram",
    name: "Telegram",
    description: "Direct entrants to a Telegram channel or group",
    icon: "https://img.promoamp.com/icons/telegram.svg",
    status: "Available",
    class: "h-[30px]",
    href: null,
    type: "Entry Actions",
    service: "telegram",
  },
  {
    id: "linkedin",
    name: "LinkedIn",
    description: "Direct entrants to a LinkedIn profile, company or post",
    icon: "https://img.promoamp.com/icons/linkedin.svg",
    status: "Available",
    class: "h-[30px]",
    href: null,
    type: "Entry Actions",
    service: "linkedin",
  },
  // {
  //   id: "google",
  //   name: "Google",
  //   description: "Google-related entry actions",
  //   icon: "https://img.promoamp.com/icons/google.svg",
  //   status: "Available",
  //   class: "h-[30px]",
  //   href: null,
  //   type: "Entry Actions",
  //   service: "google",
  // },
  // {
  //   id: "trustpilot",
  //   name: "Trustpilot",
  //   description: "Leave reviews on Trustpilot",
  //   icon: "https://img.promoamp.com/icons/trustpilot.svg",
  //   status: "Available",
  //   class: "h-[30px]",
  //   href: null,
  //   type: "Entry Actions",
  //   service: "trustpilot",
  // },
  {
    id: "apple-music",
    name: "Apple Music",
    description: "Direct entrants to Apple Music content",
    icon: "https://img.promoamp.com/icons/applemusic.svg",
    status: "Available",
    class: "h-[30px]",
    href: null,
    type: "Entry Actions",
    service: "apple-music",
  },
  {
    id: "spotify",
    name: "Spotify",
    description: "Direct entrants to a Spotify artist, playlist or track",
    icon: "https://img.promoamp.com/icons/spotify.svg",
    status: "Available",
    class: "h-[30px]",
    href: null,
    type: "Entry Actions",
    service: "spotify",
  },
  {
    id: "x-twitter",
    name: "X (Twitter)",
    description: "Direct entrants to an X profile, post or sharing flow",
    icon: "https://img.promoamp.com/icons/x.svg",
    status: "Available",
    class: "h-[30px]",
    href: null,
    type: "Entry Actions",
    service: "x-twitter",
  },
  {
    id: "youtube",
    name: "YouTube",
    description: "Direct entrants to a YouTube channel or video",
    icon: "https://img.promoamp.com/icons/youtube.svg",
    status: "Available",
    class: "h-[30px]",
    href: null,
    type: "Entry Actions",
    service: "youtube",
  },
  {
    id: "app-store",
    name: "App Store",
    description: "Direct entrants to an App Store listing",
    icon: "https://img.promoamp.com/icons/appstore.svg",
    status: "Available",
    class: "h-[30px]",
    href: null,
    type: "Entry Actions",
    service: "app-store",
  },
  {
    id: "google-play",
    name: "Google Play",
    description: "Direct entrants to a Google Play listing",
    icon: "https://img.promoamp.com/icons/playstore.svg",
    status: "Available",
    class: "h-[30px]",
    href: null,
    type: "Entry Actions",
    service: "google-play",
  },
]

// Combined integrations for the integrations page
export const allIntegrations: Integration[] = [
  ...integrations,
  ...entryActionsIntegrations,
]

// Email marketing integrations only (excluding non-email integrations like Shopify, Webhooks, Zapier)
export const emailIntegrations = integrations.filter(
  (integration) => integration.type === "Email",
)

// Entry actions integrations
export const entryActionsOnly = entryActionsIntegrations

// Helper function to check if an integration is connected
export const isIntegrationConnected = (
  integration: Integration,
  connectedIntegrations: Record<string, unknown>,
): boolean => {
  if (!integration.service) return false
  return !!connectedIntegrations[integration.service.toLowerCase()]
}
